import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import { Column } from '../Column/Column';
import { Row } from '../Row/Row';
import { Item, SelectableRectangle } from './SelectableRectangle';
import { SubItemsLabel } from './style';

export interface RectangleSelectorProps {
	items: Item[];
	selected?: Item;
	selectedSubOption?: Item;
	onSelect: (item: Item) => void;
	onSubOptionSelect: (item: Item) => void;
}

export function RectangleSelector({
	items,
	selected,
	selectedSubOption,
	onSelect,
	onSubOptionSelect,
}: RectangleSelectorProps) {
	const { t } = useTranslationsContext();

	const isSelected = (key: string) => {
		return key === selected?.key;
	};

	const isSubOptionSelected = (key: string) => {
		return key === selectedSubOption?.key;
	};

	const isDisabled = (key: string) => {
		return selected && key !== selected.key;
	};

	return (
		<>
			<Column $gap={30}>
				<Row $gap={8}>
					{items.map((feedbackOption) => (
						<SelectableRectangle
							key={feedbackOption.key}
							type={'primary'}
							item={feedbackOption}
							selected={isSelected(feedbackOption.key)}
							disabled={isDisabled(feedbackOption.key)}
							onClick={() => {
								onSelect(feedbackOption);
							}}
						/>
					))}
				</Row>
				{selected && selected.subItems && (
					<Column $gap={6}>
						<SubItemsLabel>{t('feedback.reason')}</SubItemsLabel>
						<Row $gap={8}>
							{selected.subItems.map((subFeedbackOption) => (
								<SelectableRectangle
									key={subFeedbackOption.key}
									type={'secondary'}
									item={subFeedbackOption}
									selected={isSubOptionSelected(subFeedbackOption.key)}
									onClick={() => {
										onSubOptionSelect(subFeedbackOption);
									}}
								/>
							))}
						</Row>
					</Column>
				)}
			</Column>
		</>
	);
}
